module.exports = __webpack_public_path__ + "static/img/38_clap.78533f0e.jpg";